/**
 * Match backend GET /scraper/sessions normalization so UI stays consistent with polling
 * and does not show impossible checker totals after socket partial updates.
 */
export function reconcileScraperSessionProgress(session) {
  if (!session || !session.progress) {
    return session;
  }
  const p = session.progress;
  const filters = session.filters || {};
  const ts = Math.max(0, Number(p.totalScraped) || 0);
  const out = { ...p };

  const cc = Math.max(0, Number(out.totalCountryChecked) || 0);
  if (ts > 0 && cc > ts) {
    const ratio = ts / cc;
    out.totalCountryChecked = ts;
    out.totalCountryAccepted = Math.round((Number(out.totalCountryAccepted) || 0) * ratio);
    out.totalCountryRejected = Math.round((Number(out.totalCountryRejected) || 0) * ratio);
    out.totalCountryFailed = Math.round((Number(out.totalCountryFailed) || 0) * ratio);
    const sum = out.totalCountryAccepted + out.totalCountryRejected + out.totalCountryFailed;
    out.totalCountryRejected = Math.max(0, out.totalCountryRejected + (ts - sum));
  }

  const accepted = Math.max(0, Number(out.totalCountryAccepted) || 0);
  const activityCap =
    filters.filterCountryWhitelist && filters.filterActiveLastMonth
      ? Math.min(ts, accepted)
      : ts;
  const tac = Math.max(0, Number(out.totalActivityChecked) || 0);
  if (activityCap >= 0 && tac > activityCap) {
    const ratio = activityCap > 0 ? activityCap / tac : 0;
    out.totalActivityChecked = activityCap;
    out.totalActive = Math.round((Number(out.totalActive) || 0) * ratio);
    out.totalInactive = Math.round((Number(out.totalInactive) || 0) * ratio);
    out.totalFailed = Math.round((Number(out.totalFailed) || 0) * ratio);
    const sum = out.totalActive + out.totalInactive + out.totalFailed;
    out.totalInactive = Math.max(0, out.totalInactive + (activityCap - sum));
  }

  // Cap totalStored by the enabled-filter outcome. Keeps the session card in
  // sync with the real Extract-New pool when legacy drift left totalStored
  // ahead of totalActive (see reconcileScraperSessionProgress.js backend for
  // the rationale).
  const storedCap = filters.filterActiveLastMonth
    ? Math.max(0, Number(out.totalActive) || 0)
    : filters.filterCountryWhitelist
      ? Math.max(0, Number(out.totalCountryAccepted) || 0)
      : ts;
  const ts2 = Math.max(0, Number(out.totalStored) || 0);
  if (ts2 > storedCap) {
    out.totalStored = storedCap;
  }

  return {
    ...session,
    progress: {
      ...out,
      usernameStatus: p.usernameStatus
    }
  };
}
